import isVerifactuFeatureFlagAddBusinessActive from 'modules/App/hooks/useVerifactuFeatureFlagAddBusinessActive';
import isVerifactuFeatureFlagInvoiceActive from 'modules/App/hooks/useVerifactuFeatureFlagInvoiceActive';
import isVerifactuFeatureFlagRegisterActive from 'modules/App/hooks/useVerifactuFeatureFlagRegisterActive';
import { isNavarraProvince } from 'modules/Bookkeeper/AddClient/helpers/navarraProvince';

import {
  hasBaiElectronicDocumentProvider,
  hasVerifactuElectronicDocumentProvider,
  shouldSendElectronicDocumentToVerifactu,
} from '../businessUtils';
import Business from '../models/business';

export const useBusinessVerifactu = (business: Business) => {
  const isVerifactu = hasVerifactuElectronicDocumentProvider(business);
  const isVerifactuActiveForInvoice =
    checkBusinessVerifactuActiveForInvoice(business);
  const isVerifactuActiveForRegister =
    checkBusinessVerifactuActiveForRegister(business);
  const isVerifactuActiveForCreateBusiness =
    checkBusinessVerifactuActiveForCreateBusiness(business);
  const isVerifactuConnected =
    shouldSendElectronicDocumentToVerifactu(business);
  const isVerifactuCandidate = checkIsVerifactuCandidate(business);
  const isVerifactuNotConnected = isVerifactu && !isVerifactuConnected;

  const isVerifactuIGIC = checkIsBusinessVerifactuIGIC(business);
  const isVerifactuIPSI = checkIsBusinessVerifactuIPSI(business);
  const isVerifactuIVA = isVerifactu && !isVerifactuIGIC && !isVerifactuIPSI;

  return {
    isVerifactu,
    isVerifactuConnected,
    isVerifactuNotConnected,
    isVerifactuCandidate,
    isVerifactuActiveForInvoice,
    isVerifactuActiveForRegister,
    isVerifactuActiveForCreateBusiness,
    isVerifactuIGIC,
    isVerifactuIPSI,
    isVerifactuIVA,
  };
};

export const checkIsBusinessVerifactuIGIC = (business: Business) => {
  const isVerifactuConnected =
    shouldSendElectronicDocumentToVerifactu(business);
  const province = business?.address?.province;
  return isVerifactuConnected && (province === 'ES-TF' || province === 'ES-GC');
};

export const checkIsBusinessVerifactuIPSI = (business: Business) => {
  const isVerifactuConnected =
    shouldSendElectronicDocumentToVerifactu(business);
  const province = business?.address?.province;
  return isVerifactuConnected && (province === 'ES-ML' || province === 'ES-CE');
};

export const checkIsBusinessVerifactuIVA = (business: Business) => {
  const isVerifactuConnected =
    shouldSendElectronicDocumentToVerifactu(business);
  return (
    isVerifactuConnected &&
    !checkIsBusinessVerifactuIGIC(business) &&
    !checkIsBusinessVerifactuIPSI(business)
  );
};
const checkBusinessVerifactuActiveForInvoice = (business: Business) => {
  const isVerifactuInvoiceActive = isVerifactuFeatureFlagInvoiceActive();
  const isVerifactuCandidate = checkIsVerifactuCandidate(business);
  const isVerifactu = hasVerifactuElectronicDocumentProvider(business);

  const shouldRenderVerifactu = isVerifactuCandidate || isVerifactu;
  return isVerifactuInvoiceActive && shouldRenderVerifactu;
};

const checkBusinessVerifactuActiveForRegister = (business: Business) => {
  const isVerifactuInvoiceActive = isVerifactuFeatureFlagRegisterActive();
  const isVerifactu = hasVerifactuElectronicDocumentProvider(business);
  return isVerifactuInvoiceActive && isVerifactu;
};

const checkBusinessVerifactuActiveForCreateBusiness = (business: Business) => {
  const isVerifactuInvoiceActive = isVerifactuFeatureFlagAddBusinessActive();
  const isVerifactu = hasVerifactuElectronicDocumentProvider(business);
  return isVerifactuInvoiceActive && isVerifactu;
};

const checkIsVerifactuCandidate = (business: Business) => {
  const isBai = hasBaiElectronicDocumentProvider(business);
  const isNavarra = business && isNavarraProvince(business?.address?.province);
  const isVerifactu = hasVerifactuElectronicDocumentProvider(business);
  return !isNavarra && !isBai && !isVerifactu;
};
